import { render } from "./ReportSickDaysDefaultView.vue?vue&type=template&id=e1d7bb52"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__